import React from 'react';
import Accountants from '../Sections/ExternalAdvisors/Accountants';
import EstatePlanningAttorney from '../Sections/ExternalAdvisors/EstatePlanningAttorney';
import InsuranceAgent from '../Sections/ExternalAdvisors/InsuranceAgent';
import OtherProfessional from '../Sections/ExternalAdvisors/OtherProfessional';
import Navigator from '../UI/Navigator';

const OtherAdvisors = () => (
  <Navigator>
    <Accountants />
    <EstatePlanningAttorney />
    <InsuranceAgent />
    <OtherProfessional />
  </Navigator>
);

export default OtherAdvisors;
